


















































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { authModule, routerModule } from '@/store';
import { RouteData } from '@/api/Wordpress';
import CarouselIndicators from '@/components/frontend/CarouselIndicators.vue';
import FooterCta from '@/components/frontend/FooterCta.vue';
import GetQuote from '@/components/frontend/GetQuote.vue';
import BlockoutPeriodView from '@/components/frontend/BlockoutPeriod.vue';
import { BlockoutPeriod } from '@/api';

@Component({
  components: {
    CarouselIndicators,
    FooterCta,
    GetQuote,
    BlockoutPeriodView,
  },
})
export default class extends Vue {
  loading: boolean = false;
  page: RouteData | null = null;
  acf: any = null;

  bookingCarousel: number = 0;
  bookingCarouselSlides: number = 3;

  quoteCarousel: number = 0;
  quoteCarouselSlides: number = 0;

  blockoutPeriod: BlockoutPeriod | null = null;
  message: string = '';

  get isLoggedIn() {
    return authModule.isLoggedIn;
  }

  loginRegister() {
    authModule.openLoginDialog({ cb: null });
  }

  subscribe() {
    this.$router.push({
      name: 'profile',
      query: { tab: 'subscribe' },
    });
  }

  initQuoteCarousel() {
    if (!this.acf || !this.acf.quotes) {
      return;
    }

    this.quoteCarouselSlides = this.acf.quotes.length;
  }

  async getCurrentFormBlockout() {
    const currentUrl = `${BlockoutPeriod.url()}current_form_blockout/`;
    const res = await fetch(currentUrl);
    const json = await res.json();
    this.blockoutPeriod = null;
    if (json.data) {
      const item = json.data
      this.blockoutPeriod = new BlockoutPeriod({
        ...item.attributes,
        id: item.id,
      })
    }
  }

  async mounted() {
    try {
      this.loading = true;
      this.page = await routerModule.getHome();

      if (this.page.acf) {
        this.acf = this.page.acf;
      }

      this.initQuoteCarousel();
    } catch (e) {
      // Error
    } finally {
      this.loading = false;
    }
  }

  @Watch('isLoggedIn', { immediate: true })
  sessionChange() {
    this.getCurrentFormBlockout()
  }
}
